import styled from 'styled-components';

export const StyledTableWrapper = styled.div`
  border-top: 1px solid #e8e8e8;
`;

export const TableWrapper = styled.div`
  height: 100%;
  min-height: 500px;
`;

export const StyledHeader = styled.div`
  display: flex;
  justify-content: space-between;
  margin: 10px;
`;

export const StyledSearchWrapper = styled.div`
  .ant-input-affix-wrapper {
    display: flex !important;
  }

  input {
    background: white;
  }

  .anticon {
    vertical-align: 0.125em;
  }
`;

export const StyledTableHeader = styled.div`
  height: 50px;
  line-height: 50px;
  position: relative;

  .BaseTable__header-cell {
    padding-right: 16px;
  }

  .BaseTable__header-cell-text {
    white-space: nowrap;
  }

  .BaseTable__sort-indicator {
    margin-right: 3px;
  }

  .BaseTable__expand-icon {
    display: none;
  }

  & button {
    position: absolute;
    right: 4px;
    top: 10px;
    border: none;
    background: none;
  }

  &:hover button {
    display: inline-block;
  }
`;
